import type { TenantConfig } from '@/types/TenantConfig'

export const harlemstage: TenantConfig = {
  logo: 'assets/harlemstage/static/logo.png',
  themeOptions: {
    dialog: {
      headerBackground: '#1b1c1d',
      headerTextColor: '#ffffff',
      headerIconColor: '#ffffff',
      headerBorder: '0',
    },
    mobileFooter: {
      textColor: '#131516',
      priceTextColor: '#131516',
    },
  },
  titleInsideContentColumn: true,
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/harlemstage/static/fonts.css',
    },
  },
  i18nOverrides: {
    en: {
      completedOrdersRoute: {
        title: '<span>Thank you</span>',
      },
    },
  },
}
